import tinymce from "tinymce";
import editorControl from "../../../store/editor";
import wycContent from "../../../store/wycContent";
import contents from "../../../store/content";
// import user from "../../../store/user";
// import editorCl from "./editorControl";
// //1.引入vue
// import Vue from "vue";
// //2.新创建一个vue实例
// let v = new Vue();
let getMsg = "";
const selection = root => {
  try {
    return root
      .getSelection()
      .getRangeAt(0)
      .cloneContents().textContent;
  } catch (e) {
    console.log(e);
    return "";
  }
};

const setTimeoutAsync = time => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, time);
  });
};
// const test = text => {
//   return text;
// };
//清除空白字符
const Trim = str => {
  return str.replace(/(^\\s*)|(\\s*$)/gi, "");
};
const init = () => {
  let contentDom = document.getElementsByClassName("article-content")[0];
  contentDom.addEventListener("mouseup", async () => {
    document.querySelectorAll("._5118-intro-btn[data-tool]").forEach(item => {
      item.parentNode.removeChild(item);
    });
    await setTimeoutAsync(10);
    let text = selection(window);
    let select = getSelection(window);
    if (text) {
      let rect = getSelectionRect(select);
      let btn = document.createElement("div");
      btn.classList.add("_5118-intro-btn");
      btn.textContent = "引入文本";
      btn.style.position = "fixed";
      btn.style.left = rect.left + (rect.width - 86) / 2 + "px";
      btn.style.zIndex = "2147483646";
      btn.style.top = rect.top - 53 + "px";
      btn.style.display = "inline-block";
      btn.style.whiteSpace = "nowrap";
      btn.style.cursor = "pointer";
      btn.style.textAlign = "center";
      btn.style.outline = "none";
      btn.style.margin = "0";
      btn.style.transition = ".1s";
      btn.style.fontWeight = "500";
      btn.style.fontSize = "14px";
      btn.style.backgroundColor = "#23c61d";
      btn.style.border = "1px solid #23c61d";
      btn.style.color = "white";
      // btn.style.padding = "10px 20px";
      btn.style.borderRadius = "20px";
      btn.style.width = "100px";
      btn.style.height = "40px";
      btn.style.lineHeight = "40px";

      let out = document.createElement("div");
      out.style.position = "absolute";
      out.style.top = "36px";
      out.style.left = "45px";
      out.style.borderTop = "10px solid #23c61d";
      out.style.borderLeft = "7px solid transparent";
      out.style.borderRight = "7px solid transparent";

      btn.appendChild(out);

      btn.addEventListener("mouseup", e => {
        e.stopPropagation();
      });

      document.addEventListener("mouseup", e => {
        e.stopPropagation();
        btn.style.display = "none";
      });

      btn.addEventListener("click", e => {
        e.stopPropagation();
        // if (user.state.userLevel >= 100) {
        btn.style.display = "none";
        text = Trim(text);
        if (!contents.state.wycShow) {
          let text_new = text.replace(
            text,
            '<p><span class="flicker">' + text + "</span></p>"
          );
          tinymce.activeEditor.insertContent(text_new);
          tinymce.activeEditor.focus();

          // setTimeout(() => {
          //   let flicker = document.querySelector(".flicker");
          //   flicker.className = "";
          // }, 1000);
        } else {
          wycContent.state.wycContent = text;
        }
        // } else {
        //   btn.style.display = "none";
        //   editorCl.showUpgrade(true, "升级获得使用权");
        // }
      });
      btn.dataset["tool"] = Date.now().toString();
      document.body.appendChild(btn);
    }
  });
};
const init2 = () => {
  console.log(editorControl.state.sentence);
  let iframe = document.getElementsByClassName("tox-edit-area__iframe")[0];
  iframe.contentWindow.document.addEventListener("mouseup", async () => {
    iframe.contentWindow.document
      .querySelectorAll("._5118-intro-btn[data-tool]")
      .forEach(item => {
        item.parentNode.removeChild(item);
      });
    await setTimeoutAsync(10);
    let text = selection(iframe.contentWindow);
    let select = getSelection(iframe.contentWindow);
    console.log(iframe.contentWindow.parent);
    if (text) {
      let rect = getSelectionRect(select);
      let btn = iframe.contentWindow.document.createElement("button");
      btn.classList.add("_5118-intro-btn");
      btn.textContent = "整句智能原创";
      btn.style.position = "fixed";
      btn.style.left = rect.left + (rect.width - 86) / 2 + "px";
      btn.style.zIndex = "2147483646";
      btn.style.top = rect.top - 47 + "px";
      btn.style.display = "inline-block";
      btn.style.whiteSpace = "nowrap";
      btn.style.cursor = "pointer";
      btn.style.textAlign = "center";
      btn.style.outline = "none";
      btn.style.margin = "0";
      btn.style.transition = ".1s";
      btn.style.fontWeight = "500";
      btn.style.padding = " .3em 1em";
      btn.style.fontSize = "14px";
      btn.style.backgroundColor = "#5388f8";
      btn.style.border = "1px solid #5388f8";
      btn.style.color = "white";
      btn.style.borderRadius = "2px";
      btn.style.padding = "10px 10px";
      btn.contenteditable = false;

      btn.addEventListener("mouseup", e => {
        e.stopPropagation();
      });

      btn.addEventListener("click", e => {
        e.stopPropagation();
        btn.style.display = "none";
        getMsg = Trim(text);
        window.postMessage(
          { cmd: "_5118_send_sentence", sendMsg: getMsg },
          "*"
        );
      });
      btn.dataset["tool"] = Date.now().toString();
      iframe.contentWindow.document.body.appendChild(btn);
    }
  });
};
const getSelection = root => {
  let t = null;
  if (root.getSelection) {
    t = root.getSelection();
  } else if (root.document.getSelection) {
    t = root.document.getSelection();
  } else if (root.document.selection) {
    t = root.document.selection.createRange().text;
  }
  return t;
};

const getSelectionRect = selection => {
  if (selection.rangeCount <= 0) {
    return null;
  }

  const _rect = selection.getRangeAt(0).getBoundingClientRect();
  let rect =
    _rect && _rect.top ? _rect : selection.getRangeAt(0).getClientRects()[0];
  if (!rect) {
    if (selection.anchorNode && selection.anchorNode.getBoundingClientRect) {
      rect = selection.anchorNode.getBoundingClientRect();
    } else {
      return null;
    }
  }
  return rect;
};
export { init, init2, getMsg };
